export default function FastFormQuestion(props) {
    return (
        <div className={props.inline ? "pe-1 d-inline": ""}>
            {props.text}
            {
                props.required ?
                <span className="ps-1 text-danger fw-bold">*</span>
                :
                <></>
            }
        </div>
    )
}